import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "sypama_consent";
export const CONSENT_VERSION = "1.0";

const DEFAULTS = { statistics: false, marketing: false, externalMedia: false };

const ConsentContext = createContext(null);

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(null);
  const [bannerOpen, setBannerOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        setConsent(JSON.parse(raw));
      } else {
        setBannerOpen(true);
      }
    } catch {
      setBannerOpen(true);
    }
  }, []);

  const save = useCallback(async (choices) => {
    const record = {
      consentId:
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      necessary: true,
      ...DEFAULTS,
      ...choices,
      version: CONSENT_VERSION,
      timestamp: new Date().toISOString(),
    };
    setConsent(record);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {}
    setBannerOpen(false);
    try {
      await axios.post(`${API}/consent`, record);
    } catch {}
  }, []);

  const openSettings = useCallback(() => setBannerOpen(true), []);
  const hasConsent = useCallback((category) => Boolean(consent && consent[category]), [consent]);

  return (
    <ConsentContext.Provider
      value={{ consent, decided: Boolean(consent), bannerOpen, save, openSettings, hasConsent }}
    >
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  return useContext(ConsentContext);
}
